import { Controller } from "@hotwired/stimulus"

// Truncates rich text content to a character limit with Show more/less toggle
export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = { limit: { type: Number, default: 280 }, expanded: { type: Boolean, default: false } }

  connect() {
    this.originalHTML = this.contentTarget.innerHTML
    this.plainText = this.contentTarget.textContent.trim()

    if (this.plainText.length > this.limitValue) {
      this.collapse()
      this.toggleTarget.classList.remove("hidden")
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.expandedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.innerHTML = this.originalHTML
    this.toggleTarget.textContent = "Show less"
    this.expandedValue = true
  }

  collapse() {
    const truncated = this.plainText.substring(0, this.limitValue) + "..."
    this.contentTarget.textContent = truncated
    this.toggleTarget.textContent = "Show more"
    this.expandedValue = false
  }
}
